import type { QuestionId } from '../../types/ids';

/**
 * Fallback-Zuordnung für fachlich besonders kritische Fragen (Abschnitt 18, FR-INSIGHT-002),
 * damit ein kritischer Engpass auch dann zu konkreten Handlungsschritten führt, wenn (noch)
 * kein Spannungsfeld dieselbe Frage referenziert. Nutzt ausschließlich vorhandene Empfehlungs-IDs
 * aus `08-recommendation-rules.json`.
 */
export const CRITICAL_QUESTION_RECOMMENDATIONS: Partial<Record<QuestionId, string[]>> = {
  audience_activity: ['verify_audience_presence', 'compare_alternative_channels'],
  offer_proof: ['validate_offer_with_real_buyers', 'start_with_direct_conversations'],
  sales_path: ['build_sales_path_first', 'define_one_next_step'],
  instagram_independence: ['build_email_list', 'strengthen_website'],
};
